<template>
  <div
    class="grid-x nowrap"
    :class="{
      'convo-commerce': (isDesktop || isBcom) && isAiScriptEnabled,
    }"
  >
    <SearchInput />
    <transition name="fade">
      <div v-if="(isDesktop || isBcom) && isAiScriptEnabled && isDomestic" v-show="!isSearchModalActive" class="convo-commerce-wrapper">
        <AskAI />
      </div>
    </transition>
  </div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, onMounted } from 'vue';
import { SET_SEARCH_VALUE, APPLY_SEARCH_TERM } from '#shared/types/actions';
import { useQueryParams } from '~/composables/dumb/useQueryParams';
import SearchInput from '~/components/search/SearchInput.common';
import useAskAiVisibility from '~/composables/useAskAiVisibility';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import AskAI from '../link-rail/AskAI.common';

const navHeader = useNavHeader();
const query = useQueryParams();
const { isAiScriptEnabled } = useAskAiVisibility();
const navViewType = useNavViewType();
const { isBcom } = useEnvProps();

const pageData = usePageData();
const isDomestic = computed(() => pageData.navigation.context.isDomestic);

const isSearchModalActive = computed(() => navHeader.isSearchModalActive);
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);

const searchValue = computed({
  get() {
    return navHeader.searchValue;
  },
  set(value) {
    navHeader[SET_SEARCH_VALUE](value);
  },
});

onMounted(() => {
  // business requested to not apply searchValue in search bar if ZOR is true
  if (query?.isZoneOfRelevance === 'true') {
    searchValue.value = '';
  } else {
    navHeader[APPLY_SEARCH_TERM]();
  }
});
</script>

<style lang="scss"></style>

<style lang="scss" brand="mcom">
.convo-commerce-wrapper {
  position: relative;
  height: 40px;
  display: block;
  width: 107px;
  margin-left: 14px;
  padding-top: 0;
}

@include breakpoint(large up) {
  .convo-commerce-wrapper {
    width: 187px; // 80px help reserve enough space for AskAi btn to load without search jumping
  }
}
</style>

<style lang="scss" brand="bcom">
.convo-commerce-wrapper {
  margin-left: 8px;
  position: relative;
}

@include breakpoint(large up) {
  .convo-commerce-wrapper {
    width: 69px;
  }
}
</style>
